import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToolbarDetails {
  title?: string;
  isBack?: boolean;
  isShopFiltered?: boolean;
  shopName?: string;
  isShopService?: boolean;
  customerName?: string;
  isCustomerService?: boolean;
}

export interface NavbarBtn {
  action: 'add' | 'delete' | 'edit' | 'refresh' | 'search' | 'filter' | 'share' | 'call' | 'expressjob';
  state?: null;
  icon?: string; 
  image?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private userType: 'tobeonline' | 'servicenear' = 'tobeonline';

  public toolbarDetails: ToolbarDetails = {}

  //NAVBAR BUTTONS
  public navbarButtons: NavbarBtn[] = [];
  //TO EMIT WHICH BUTTON HAS CLICKED
  private buttonClick = new Subject<NavbarBtn | null>();
  buttonClicked$ = this.buttonClick.asObservable();

  private routeReattach = new Subject<string>();
  /** Emits the routeKey whenever a cached list component is reattached by RouteReuseStrategy. */
  routeReattached$ = this.routeReattach.asObservable();

  constructor() { }

  setUserType(type: 'tobeonline' | 'servicenear') {
    this.userType = type;
  }

  getUserType() {
    return this.userType;
  }

  setToolbar(details: ToolbarDetails) {
    this.toolbarDetails = details;
  }

  //NAVBAR BUTTONS SETTER AND CLICK EMITTER

  setNavbarButtons(buttons: NavbarBtn[]): void {
    this.navbarButtons = buttons;
  }

  emitButtonClick(clickedBtn: NavbarBtn): void {
    this.buttonClick.next(clickedBtn);
  }

  /** Called by CustomRouteReuseStrategy when a cached component is reattached. */
  notifyRouteReattached(routeKey: string): void {
    this.routeReattach.next(routeKey);
  }

}
